module.exports = __webpack_public_path__ + "img/ifma.a905e10e.png";